module.exports = __webpack_public_path__ + "static/media/lombardia_granda_stewart_long_macaluso.0c287834.jpg";